<template>
  <v-dialog
    v-model="isOpen"
    class="modal-max-width"
    :style="zIndex ? `z-index: ${zIndex}` : '' "
    persistent
  >
    <v-card class="pt-6 pb-3">
      <v-card-title class="pb-3 title-font text-center">
        <slot name="title" />
      </v-card-title>
      <v-card-text class="body-font body-max-height py-0 text-pre-wrap overflow-auto">
        <slot name="contents" />
      </v-card-text>
      <v-divider v-if="addDividerToFooter" class="mt-3" :thickness="2" />
      <v-card-actions class="px-5" :class="addDividerToFooter ? 'mt-3' : 'mt-6'">
        <div class="w-100">
          <slot name="actionButtons" />
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
const isOpen = defineModel<boolean>('isOpen');
defineProps<{
  addDividerToFooter?: boolean;
  zIndex?: number;
}>();
</script>

<style lang="scss" scoped>
@use '~/assets/scss/_base.scss' as vars;

.modal-max-width {
  max-width: vars.$modal-max-width;
}

.title-font {
  font-size: 1.25rem;
  font-weight: bold;
}

.body-font {
  font-size: 1.25rem;
  font-weight: 300;
}

.body-max-height {
  max-height: 500px;
}

button {
  font-size: 1.25rem;
  font-weight: bold;
}
</style>
